import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import Content from './Content';

const ContentWithContext = (props) => {
  const {
    setModalCollection,
  } = useModalContext();

  return <Content {...props} setCollection={setModalCollection} />;
};

export default ContentWithContext;
